import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TimerState {
    isOpen: boolean;
}

const initialState: TimerState = {
    isOpen: false,
};

export const timerSlice = createSlice({
    name: 'timer',
    initialState,
    reducers: {
        openTimer: (state) => {
            state.isOpen = true;
        },
        closeTimer: (state) => {
            state.isOpen = false;
        },
        toggleTimer: (state) => {
            state.isOpen = !state.isOpen;
        },
        setTimerOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
    },
});

export const { openTimer, closeTimer, toggleTimer, setTimerOpen } = timerSlice.actions;
export default timerSlice.reducer;
